import {Component, Input, OnInit} from '@angular/core';
import {DocumentModel} from '../../models/document.model';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {LokijsService} from '../../services/database/lokijs.service';
import {ModalController} from '@ionic/angular';
import {BarcodeScanner} from '@ionic-native/barcode-scanner/ngx';
import {RefreshdatabaseService} from '../../services/database/refreshdatabase.service';

@Component({
    selector: 'app-order-fulfil-specific-item',
    templateUrl: './order-fulfil-specific-item.page.html',
    styleUrls: ['./order-fulfil-specific-item.page.scss'],
})
export class OrderFulfilSpecificItemPage implements OnInit {
    @Input() document: DocumentModel;
    @Input() detailLine: DetaillineDTOModel;
    equipments: DetaillineDTOModel[];
    equipmentList: any;
    queryText = '';
    count = 0;

    constructor(private loki: LokijsService,
                private modalController: ModalController,
                private barcodeScanner: BarcodeScanner,
                private refreshDB: RefreshdatabaseService) {
    }

    async ngOnInit() {
        console.log('get collection equipmentList start = ' + new Date());
        this.equipments = await this.loki.getCollection('equipment').chain().find({stat: 1, pdesc: this.detailLine.pdesc}).data();
        console.log('get Collection equipmentList end = ' + new Date());
        console.log(this.equipments);
        if (this.equipments) {
            this.equipmentList = [];
            for (const equip of this.equipments) {
                this.equipmentList.push({equipment: equip as DetaillineDTOModel, isChecked: false});
            }
        }
        console.log('populating equipmentList start = ' + new Date());
        this.populateEquipmentList();
        console.log('populating checkfulfil start = ' + new Date());
        this.checkFulfil();
        console.log('populating checkfulfil end = ' + new Date());
        console.log(this.equipmentList);
    }

    checkFulfil() {
        this.count = 0;
        for (const item of this.equipmentList) {
            if (item.isChecked) {
                this.count++;
            }
        }
        if (this.count === this.detailLine.qty) {
            this.closeModal();
        }
    }

    closeModal() {
        const returnList = [];
        for (const item of this.equipmentList) {
            if (item.isChecked) {
                let tempDetailLine = new DetaillineDTOModel();
                tempDetailLine = JSON.parse(JSON.stringify(this.detailLine));
                tempDetailLine.originalDetailLine = JSON.parse(JSON.stringify(this.detailLine));
                tempDetailLine.documentNumber = null;
                tempDetailLine.detailLineId = 0;
                tempDetailLine.reg = item.equipment.reg;
                tempDetailLine.qty = 1;
                tempDetailLine.typ = item.equipment.typ;
                if (!tempDetailLine.overrideDescriptionNote) {
                    tempDetailLine.overrideDescriptionNote = item.equipment.description;
                }
                returnList.push(tempDetailLine);
            }
        }
        this.modalController.dismiss(returnList);
    }

    populateEquipmentList() {
        if (this.document.detailLines.length > 0) {
            for (const line of this.document.detailLines) {
                for (const item of this.equipmentList) {
                    if (line.pdesc === item.equipment.pdesc && line.reg === item.equipment.reg) {
                        item.isChecked = true;
                    }
                }
            }
            this.equipmentList.sort((a, b) => (a.isChecked < b.isChecked) ? 1 : -1);
        }
    }

    scanCode() {
        this.barcodeScanner
            .scan()
            .then(data => {
                console.log(JSON.stringify(data));
                if (data.text && data.text !== '') {
                    this.findBarcode(data.text);
                }
            })
            .catch(err => {
                console.log('Error', err);
            });
    }

    findBarcode(serial: string) {
        this.equipmentList.forEach(item => {
            const tempString = item.equipment.serial.split('-');
            const tempSerial = tempString.join('');
            console.log(tempSerial);
            if (tempSerial.length > 0 && serial.includes(tempSerial)) {
                item.isChecked = true;
            }

            if (tempSerial.length > 0 && serial.includes(item.serial)) {
                item.isChecked = true;
            }
        });
    }

    fetchEquipment(event) {
        this.refreshDB.refreshPlantHireResource();
        setTimeout(() => {
            console.log('Async operation has ended');
            event.target.complete();
        }, 2000);
    }
}
